var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBackAbu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 18L0.419997 10.46C0.160926 10.1916 0.0161438 9.83307 0.0161438 9.46001C0.0161438 9.08694 0.160926 8.72844 0.419997 8.46001L8.42 0.460006C8.68843 0.200935 9.04694 0.0561523 9.42 0.0561523C9.79306 0.0561523 10.1516 0.200935 10.42 0.460006C10.6838 0.725968 10.8318 1.0854 10.8318 1.46001C10.8318 1.83461 10.6838 2.19404 10.42 2.46001L4.42 8.46001C4.16547 8.73077 4.02376 9.08839 4.02376 9.46001C4.02376 9.83162 4.16547 10.1892 4.42 10.46L10 16C10.2591 16.2684 10.4039 16.6269 10.4039 17C10.4039 17.3731 10.2591 17.7316 10 18C9.73156 18.2591 9.37306 18.4039 9 18.4039C8.62694 18.4039 8.26843 18.2591 8 18Z",
    fill: "#424244"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackAbu);
export default __webpack_public_path__ + "static/media/Icon_Back_Abu.32017686.svg";
export { ForwardRef as ReactComponent };